// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import { getNotifyStyle } from "@pace/App/Components/Notify";
import { customCreateAccountStyles } from "@pace/App/Widgets/CustomCreateAccount/CustomCreateAccount";
import { mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import breakpointMediaQueries from "@pace/XDL/Utilities/breakpointMediaQueries";
import { css } from "styled-components";

customCreateAccountStyles.mainGridContainer = {
    offsetCss: css`
        flex-direction: column;
        align-items: center;
        ${xScreen("lte", "xs")} {
            align-items: flex-start;
        }
    `,
};
customCreateAccountStyles.userGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

customCreateAccountStyles.existingCustomerGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.existingCustomerRadioGroup = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
customCreateAccountStyles.customSiteMessage = {
    css: css`
        font-size: 14px;
        border-top: 1px solid ${getColor("common.border")};
        margin: 0 0 12px 0;
        padding: 8px 0 0 0;
        width: 300px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

customCreateAccountStyles.centeredGridItem = {
    width: 12,
    css: css`
        justify-content: center;
        padding-top: 0;
        text-align: center;
    `,
};
customCreateAccountStyles.applicationsButton = {
    css: css`
        width: 300px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
customCreateAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.submitButton = {
    css: css`
        width: 300px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

customCreateAccountStyles.userGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 300px;
                    `,
                ],
                "min",
            )}
    `,
};
customCreateAccountStyles.firstNameGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
        justify-content: center;
    `,
};
customCreateAccountStyles.lastNameGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.emailGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.phoneNumberGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.positionGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.accountNumberGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.accountNumberRadioGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
        justify-content: center;
    `,
};
customCreateAccountStyles.submitErrorGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
        justify-content: center;
    `,
};
customCreateAccountStyles.submitErrorTitle = {
    ...mergeWithCss(getNotifyStyle("danger"), {
        css: css`
            margin: 0;
            width: 300px;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};
customCreateAccountStyles.accountNumberRadioGroup = {
    css: css`
        width: 300px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
customCreateAccountStyles.textFieldStyle = {
    cssOverrides: {
        formField: css`
            &&& {
                width: 300px;
                ${xScreen("lte", "xs")} {
                    width: 100%;
                }
            }
        `,
    },
};

customCreateAccountStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

customCreateAccountStyles.companyNameGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
customCreateAccountStyles.companyAddressGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};